export default __webpack_public_path__ + "static/media/error.8f5af9a4.svg";